import { render } from "./QuickForm.vue?vue&type=template&id=6c1d2589&scoped=true"
import script from "./QuickForm.vue?vue&type=script&lang=js"
export * from "./QuickForm.vue?vue&type=script&lang=js"

import "./QuickForm.vue?vue&type=style&index=0&id=6c1d2589&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1d2589"]])

export default __exports__